// Clerk's cookies: session token, client, the JS-readable
// UAT marker, the dev-browser JWT, and the handshake cookies.
// Matching by prefix covers the per-instance suffixed
// variants (e.g. `__client_uat_<hash>`) without needing the
// publishable key.
export const CLERK_COOKIE_PREFIXES = [
  '__session',
  '__client',
  '__clerk',
  '__refresh',
] as const;

// Clerk sets cookies on both the host and the apex, so
// expiring one name means emitting both.
export const CLERK_COOKIE_APEX_DOMAIN = '.goclai.com';
